import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { useOverlay } from '@flipster/overlay';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css/css';
import { center } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { LossProtectionEvent } from '@flipster/utils/segment/events/loss-protection';

import LossProtectModal from '@web/app/[locale]/(web)/_modal/LossProtectModal';
import LossProtectionIcon from '@web/assets/images/loss-protection/icon-loss-protection.png';

import { lossProtectionBunja } from './bunja';

/**
 * trade 페이지에 노출되는 orderform 상단 배너
 * figma: https://www.figma.com/design/ZsFHj6mtkl2qO786Sk1sxk/Timetrigger?node-id=901-3838&m=dev
 */
const LossProtectedBanner = () => {
  const transTrade = useTranslations('Trade.r250401');
  const overlay = useOverlay();

  const { isLossProtectedAtom } = useBunja(lossProtectionBunja);
  const isLossProtected = useAtomValue(isLossProtectedAtom);

  useEffect(() => {
    if (!isLossProtected) return;
    segment.track(LossProtectionEvent.LossProtectionTooltipView, {
      event_location: 'order_form_page',
    });
  }, [isLossProtected]);

  return (
    <div
      role='button'
      className={center({
        gap: 8,
        py: 6,
        bgColor: 'background.accent.promotion.tint',
        color: 'content.accent.promotion',
        cursor: 'pointer',
        borderTopRadius: 10,
      })}
      onClick={() => {
        segment.track(LossProtectionEvent.LossProtectionTooltipClick);
        overlay.open(({ isOpen, onClose, unmount }) => (
          <LossProtectModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
        ));
      }}
    >
      <img src={LossProtectionIcon.src} alt='icon-loss-protection' className={css({ width: 16, height: 16 })} />
      <span className={css({ textStyle: 'Text/S/Strong' })}>{transTrade('Promo_loss_protection_banner')}</span>
      <ChevronRightIcon size={16} />
    </div>
  );
};

export default LossProtectedBanner;
